import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { CloseIcon } from '@chakra-ui/icons';

let toastId = 0;

const Toast = (() => {
  let addToastFn;

  const ToastComponent = () => {
    const [toasts, setToasts] = useState([]);

    useEffect(() => {
      addToastFn = addToast;
    }, []);

    const removeToast = (id) => {
      setToasts((prevToasts) =>
        prevToasts.map((toast) =>
          toast.id === id ? { ...toast, isExiting: true } : toast
        )
      );
      setTimeout(() => {
        setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
      }, 500); // Match this with your animation duration
    };

    const addToast = (message, type) => {
      const id = ++toastId;
      setToasts((prevToasts) => [...prevToasts, { id, message, type, isExiting: false }]);
      setTimeout(() => removeToast(id), 5000); // Auto remove after 5 seconds
    };

    const getToastStyle = (type) => {
      switch (type) {
        case 'success':
          return { backgroundColor: '#48BB78', borderColor: '#2F855A' }; // Green
        case 'error':
          return { backgroundColor: '#F56565', borderColor: '#C53030' }; // Red
        case 'warning':
          return { backgroundColor: '#ED8936', borderColor: '#C05621' }; // Orange
        default:
          return { backgroundColor: '#4A5568', borderColor: '#2D3748' }; // Gray
      }
    };

    return createPortal(
      <>
        <style>
          {`
          @keyframes slideIn {
            from { transform: translateX(100%); opacity: 0; }
            to { transform: translateX(0); opacity: 1; }
          }
          @keyframes slideOut {
            from { transform: translateX(0); opacity: 1; }
            to { transform: translateX(100%); opacity: 0; }
          }
          `}
        </style>
        <div style={toastContainerStyle}>
          {toasts.map((toast) => (
            <div
              key={toast.id}
              style={{
                ...toastStyle,
                ...getToastStyle(toast.type),
                animation: toast.isExiting
                  ? 'slideOut 0.5s ease forwards'
                  : 'slideIn 0.5s ease',
              }}
            >
              <div style={toastContentStyle}>
                <div style={toastTitleStyle}>{toast.type.toUpperCase()}</div>
                <div style={toastMessageStyle}>{toast.message}</div>
              </div>
              <CloseIcon
                style={closeButtonStyle}
                onClick={() => removeToast(toast.id)}
              />
            </div>
          ))}
        </div>
      </>,
      document.body
    );
  };

  const toastContainerStyle = {
    position: 'fixed',
    top: '20px',
    right: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    zIndex: 9999,
  };

  const toastStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 20px',
    borderRadius: '8px',
    color: '#fff',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    maxWidth: '300px',
    borderRight: '5px solid', // Changed from borderLeft to borderRight
    fontFamily: 'Arial, sans-serif',
  };

  const toastContentStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  };

  const toastTitleStyle = {
    fontWeight: 'bold',
    fontSize: '14px',
  };

  const toastMessageStyle = {
    fontSize: '14px',
  };

  const closeButtonStyle = {
    cursor: 'pointer',
    marginLeft: '10px',
    color: '#fff',
    fontSize: '12px',
    transition: 'transform 0.2s ease',
  };

  return {
    success: (message) => addToastFn(message, 'success'),
    error: (message) => addToastFn(message, 'error'),
    warning: (message) => addToastFn(message, 'warning'),
    ToastComponent,
  };
})();

export default Toast;